import React from 'react';
import { Modal, Button, Typography, Space } from 'antd';
import { ExclamationCircleOutlined, CrownOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

interface TrialLimitModalProps {
  visible: boolean;
  onClose: () => void;
  usedTimes: number;
  totalTimes: number;
}

const TrialLimitModal: React.FC<TrialLimitModalProps> = ({
  visible,
  onClose,
  usedTimes,
  totalTimes,
}) => {
  const handleUpgrade = () => {
    // 这里可以添加升级到Pro版本的逻辑
    console.log('升级到Pro版本');
    onClose();
  };

  return (
    <Modal
      title={
        <Space>
          <ExclamationCircleOutlined style={{ color: '#faad14' }} />
          <span>试用版本限制</span>
        </Space>
      }
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          我知道了
        </Button>,
        <Button
          key="upgrade"
          type="primary"
          icon={<CrownOutlined />}
          onClick={handleUpgrade}
        >
          升级到Pro版本
        </Button>,
      ]}
      centered
      width={480}
    >
      <div style={{ padding: '20px 0' }}>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div style={{ textAlign: 'center' }}>
            <Title level={4} style={{ color: '#faad14', marginBottom: 8 }}>
              已达到最大使用次数
            </Title>
            <Text type="secondary">
              您当前使用的是试用版本，已使用 {usedTimes}/{totalTimes} 次任务生成机会
            </Text>
          </div>
          
          <div style={{ 
            background: '#f6ffed', 
            border: '1px solid #b7eb8f',
            borderRadius: 6,
            padding: 16,
            textAlign: 'center'
          }}>
            <Space direction="vertical" size="small">
              <CrownOutlined style={{ fontSize: 24, color: '#52c41a' }} />
              <Title level={5} style={{ margin: 0, color: '#52c41a' }}>
                升级到Pro版本
              </Title>
              <Text style={{ fontSize: 12, color: '#666' }}>
                • 无限次任务生成<br />
                • 更多高级功能<br />
                • 优先技术支持
              </Text>
            </Space>
          </div>
          
          <Text type="secondary" style={{ fontSize: 12, textAlign: 'center', display: 'block' }}>
            如需继续使用任务生成功能，请升级到Pro版本
          </Text>
        </Space>
      </div>
    </Modal>
  );
};

export default TrialLimitModal;